import React, { useEffect, useState, useRef } from 'react'
import AddOrEditFileDialog from "./fileBrowser/AddOrEditFileDialog";
import localforage from "localforage";
import { nubisDriveCapacityAPI } from "../apis/nubisDriveCapacityAPI";
import { transformedFormatBytes } from "../helpers/formatBytesTransformer";

const UploadFile = ({open, onClose, onSuccess, type}) => {

  const [usageValue, setUsageValue] = useState("-");
  const [refreshCapacity, setRefreshCapacity] = useState(false);
  const [storageValue, setStorageValue] = useState("-");
  const [isFECHQ, setIsFECHQ] = useState(false);
  const [capacity, setCapacity] = useState({});
  const [companyId, setCompanyId] = useState();
  const [availableStorage, setAvailableStorage] = useState("");
  const [barValue, setBarValue] = useState(0);
  const mounted = useRef();

  const getCapacityData = async () => {
    setRefreshCapacity(false);

    let capacityObj = await nubisDriveCapacityAPI();
    let userData = await localforage.getItem("user");
    let companyId = await localforage.getItem("companyId");
    setCompanyId(companyId);
    setCapacity(capacityObj);
    if (capacityObj && userData) {
      let used = transformedFormatBytes(capacityObj.used);
      let total = transformedFormatBytes(capacityObj.total);
      let isParentCompanyNull = !userData.company.parent_company_id;
      let availableStorage = capacityObj.total - capacityObj.used;

      setAvailableStorage(availableStorage);
      setUsageValue(used);

      if (isParentCompanyNull) {
        setIsFECHQ(true);
        setBarValue(Number(capacityObj.used));
        setStorageValue("unlimited");
      } else {
        let percentage = (capacityObj.used / capacityObj.total) * 100;
        setBarValue(percentage);
        setStorageValue(total);
      }

      // stored the available storage for file uploading validation
      await localforage.setItem(
        `${companyId}-availableStorage`,
        availableStorage
      );
    }
  };

  const getAvailableStorageData = async () => {
    if (!isFECHQ) {
      let availableStorage = await localforage.getItem(
        `${companyId}-availableStorage`
      );
      setAvailableStorage(availableStorage);
    } else {
      setAvailableStorage("unlimited");
    }
  };

  useEffect(() => {
    if (!mounted.current) {
      getCapacityData();
      getAvailableStorageData();
      // getStoredLinkArray();
      mounted.current = true;
    }
  });

  return (
    <AddOrEditFileDialog
      companyId={companyId}
      availableStorage={availableStorage}
      getAvailableStorageData={getAvailableStorageData}
      isFECHQ={isFECHQ}
      open={open}
      setRefreshCapacity={setRefreshCapacity}
      parentId=""
      reloadTable={() => {}}
      onClose={onClose}
      target="file"
      onSuccess={onSuccess}
      type={type}
    />
  )
}

export default UploadFile